import { useEffect } from 'react';

interface PageMetadata {
  title: string;
  description: string;
  path: string;
  image?: string;
}

const siteUrl = 'https://austindavenport.com';
const defaultImage = `${siteUrl}/social-preview.png`;

const setMeta = (selector: string, attribute: 'content' | 'href', value: string) => {
  const element = document.querySelector<HTMLMetaElement | HTMLLinkElement>(selector);
  if (element) {
    element.setAttribute(attribute, value);
  }
};

export const usePageMetadata = ({ title, description, path, image = defaultImage }: PageMetadata) => {
  useEffect(() => {
    const url = `${siteUrl}${path}`;
    document.title = title;

    setMeta('meta[name="description"]', 'content', description);
    setMeta('link[rel="canonical"]', 'href', url);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:image"]', 'content', image);
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="twitter:image"]', 'content', image);
  }, [title, description, path, image]);
};
